import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/HomeView.vue";
import Login from "../views/LoginView.vue";
import ImportData from "../views/ImportData.vue"; // Import the new component
import OrganizationsView from "../views/OrganizationsView.vue"; // Import OrganizationsView
import EditOrganization from "../views/EditOrganization.vue";
import AddOrganization from "../views/AddOrganization.vue";
import DistrictsView from "../views/DistrictsView.vue";
import DistrictForm from "../views/DistrictForm.vue";
import ContactsView from "../views/ContactsView.vue"; // Import ContactsView
import ContactForm from "../views/ContactForm.vue"; // Import ContactForm
import EmployeesView from "../views/EmployeesView.vue"; // Import EmployeesView
import ViewOrganizationView from "@/views/ViewOrganizationView.vue";
import StudentView from "../views/StudentView.vue"; // Import StudentView
import AddStudentView from "../views/AddStudentView.vue"; // Import AddStudentView
import EditStudentView from "../views/EditStudentView.vue";
import ViewStudentView from "../views/ViewStudentView.vue";
import NavigationView from "../views/NavigationView.vue";
import TripsView from "../views/TripsView.vue";
import CalendarView from "../views/CalendarView.vue";
import AddCalendarView from "../views/AddCalendarView.vue";
import EditCalendarView from "../views/EditCalendarView.vue";
import ViewCalendarView from "../views/ViewCalendarView.vue";
// Import calendar events components
import CalendarEventsView from "../views/CalendarEventsView.vue";
import AddEventView from "../views/AddEventView.vue";
import EditEventView from "../views/EditEventView.vue";
import ViewEventView from "../views/ViewEventView.vue";
import DistrictClosureView from "../views/DistrictClosureView.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: { requiresAuth: true },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/import",
    name: "ImportData",
    component: ImportData,
    meta: { requiresAuth: true },
  },
  {
    path: "/organizations", // Add route for OrganizationsView
    name: "organizations",
    component: OrganizationsView,
  },
  {
    path: "/organizations/add",
    name: "AddOrganization",
    component: AddOrganization,
  },
  {
    path: "/organizations/:id/edit",
    name: "EditOrganization",
    component: EditOrganization,
  },
  {
    path: "/organizations/:id",
    name: "ViewOrganization",
    component: ViewOrganizationView,
  },
  {
    path: "/districts",
    name: "DistrictsView",
    component: DistrictsView,
  },
  {
    path: "/districts/new",
    name: "CreateDistrict",
    component: DistrictForm,
  },
  {
    path: "/districts/:id/edit",
    name: "EditDistrict",
    component: DistrictForm,
    props: true,
  },
  {
    path: "/districts/closures",
    name: "DistrictClosure",
    component: DistrictClosureView,
    meta: { requiresAuth: true },
  },
  {
    path: "/contacts",
    name: "ContactsView",
    component: ContactsView,
  },
  {
    path: "/contacts/new",
    name: "CreateContact",
    component: ContactForm,
  },
  {
    path: "/contacts/:id/edit",
    name: "EditContact",
    component: ContactForm,
    props: true,
  },
  {
    path: "/employees",
    name: "EmployeesView",
    component: EmployeesView,
  },
  {
    path: "/students",
    name: "StudentView",
    component: StudentView,
  },
  {
    path: "/students/add",
    name: "AddStudent",
    component: AddStudentView,
  },
  {
    path: "/students/:id/edit",
    name: "EditStudent",
    component: EditStudentView,
    props: true,
  },
  {
    path: "/students/:id",
    name: "ViewStudent",
    component: ViewStudentView,
    props: true,
  },
  {
    path: "/trips",
    name: "TripsView",
    component: TripsView,
    meta: { requiresAuth: true },
  },
  {
    path: "/navigation",
    name: "Navigation",
    component: NavigationView,
    meta: { requiresAuth: true },
  },
  {
    path: "/calendar",
    name: "Calendar",
    component: CalendarView,
    meta: { requiresAuth: true },
  },
  {
    path: "/calendar/add",
    name: "AddCalendar",
    component: AddCalendarView,
    meta: { requiresAuth: true },
  },
  {
    path: "/calendar/:calendarId",
    name: "ViewCalendar",
    component: ViewCalendarView,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/calendar/:calendarId/edit",
    name: "EditCalendar",
    component: EditCalendarView,
    props: true,
    meta: { requiresAuth: true },
  },
  // Calendar Events Routes
  {
    path: "/calendar/:calendarId/events",
    name: "CalendarEvents",
    component: CalendarEventsView,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/calendar/:calendarId/events/add",
    name: "AddEvent",
    component: AddEventView,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/calendar/:calendarId/events/:eventId",
    name: "ViewEvent",
    component: ViewEventView,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/calendar/:calendarId/events/:eventId/edit",
    name: "EditEvent",
    component: EditEventView,
    props: true,
    meta: { requiresAuth: true },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem("user");
  if (
    to.matched.some((record) => record.meta.requiresAuth) &&
    !isAuthenticated
  ) {
    next({ name: "Login" });
  } else {
    next();
  }
});

export default router;
